import { getConsolePnlData } from "../../Console/Component/services/apiHandler";


export const fetchPNLData = (project_ids, browse_fs_ids, currentCompProjectId) => {
    return dispatch => {
        dispatch({type:"PNL_ACTION_START"})
        getConsolePnlData(project_ids, browse_fs_ids, currentCompProjectId).then((result)=>{
            dispatch({
                type: "PNL_FETCH_DATA",
                payload: {data: result.data, set_payload: JSON.stringify({project_ids, browse_fs_ids, currentCompProjectId})}
            })
        }).catch((err)=>{
            dispatch({
                type:"PNL_FETCH_DATA_FAILED",
                payload: err.response.data.error
            })
        })        
    }
}